// ── Icons ──────────────────────────────────────────
import ArrowUpRight from './svgs/icons/arrow-up-right.svg'
import ArrowRight from './svgs/icons/arrow-right.svg'
import MenuIcon from './svgs/icons/menu.svg'
import CloseIcon from './svgs/icons/close-icon.svg'
import LightBulbIcon from './svgs/icons/light-bulb-icon.svg'
import UserIcon from './svgs/icons/user-icon.svg'
import MailIcon from './svgs/icons/mail-icon.svg'
import CircleIcon from './svgs/icons/circle-icon.svg'
import CircleIconAlt from './svgs/icons/circle-icon-alt.svg'
import LinkedinIcon from './svgs/icons/linkedin-icon.svg'
import InstagramIcon from './svgs/icons/instagram-icon.svg'
import FacebookIcon from './svgs/icons/facebook-icon.svg'
import ArrowDown from './svgs/icons/arrow-down.svg'
import TelehealthIcon from './svgs/icons/telehealth-icon.svg'

import SolutionDesign from './svgs/icons/solution-design.svg'
import EhrIcon from './svgs/icons/solutions/ehr-icon.svg'
import MobileHealthIcon from './svgs/icons/solutions/mobile-health-icon.svg'
import PatientPortalIcon from './svgs/icons/solutions/patient-portal-icon.svg'
import HealthcareAnalytics from './svgs/icons/solutions/healthcare-analytics.svg'
import AppointmentIcon from './svgs/icons/solutions/appointment-icon.svg'
import PatientMonitoringIcon from './svgs/icons/solutions/patient-monitoring-icon.svg'
import MedicalBillingIcon from './svgs/icons/solutions/medical-billing-icon.svg'
import ClinicDecisionIcon from './svgs/icons/solutions/clinic-decision-icon.svg'
import PracticeIcon from './svgs/icons/solutions/practice-icon.svg'

// ── Icon Sets ──────────────────────────────────────
// Approach icons
import AssessmentIcon from './svgs/icons/approach/assessment-icon.svg'
import TechnologyIcon from './svgs/icons/approach/technology-icon.svg'
import DataIcon from './svgs/icons/approach/data-icon.svg'
import TestingIcon from './svgs/icons/approach/testing-icon.svg'
import MaintenanceIcon from './svgs/icons/approach/maintenance-icon.svg'
import PerformanceIcon from './svgs/icons/approach/performance-icon.svg'
import ConfigurationIcon from './svgs/icons/approach/configuration-icon.svg'

// Values icons
import TrophyIcon from './svgs/icons/values/trophy-icon.svg'
import ClientFocusIcon from './svgs/icons/values/client-focus-icon.svg'
import PartnerIcon from './svgs/icons/values/partner-icon.svg'
import LightbulbValuesIcon from './svgs/icons/values/light-bulb-icon.svg'
import CollaboIcon from './svgs/icons/values/collabo-icon.svg'

import SocialIcon from './svgs/icons/values/social-icon.svg'

// BRIDGE feature icons
import BridgeAssessmentIcon from './svgs/icons/bridge/assessment-icon.svg'
import EducationIcon from './svgs/icons/bridge/education-icon.svg'
import OfflineIcon from './svgs/icons/bridge/offline-icon.svg'
import ReferralIcon from './svgs/icons/bridge/referral-icon.svg'
import BridgeSecureIcon from './svgs/icons/bridge/secure-icon.svg'
import BridgeTreeIcon from './svgs/icons/bridge/tree-icon.svg'

// Ekiti feature icons
import ComprehensiveIcon from './svgs/icons/ekiti/comprehensive-icon.svg'
import PostCovidIcon from './svgs/icons/ekiti/post-covid-icon.svg'
import UssdIcon from './svgs/icons/ekiti/ussd-icon.svg'

import EkitiSecureIcon from './svgs/icons/ekiti/secure-icon.svg'
import InterfaceIcon from './svgs/icons/ekiti/interface-icon.svg'

// KNCV feature icons
import KncvComprehensiveIcon from './svgs/icons/kncv/comprehensive-icon.svg'
import IntegrationIcon from './svgs/icons/kncv/integration-icon.svg'
import KncvSecureIcon from './svgs/icons/kncv/secure-icon.svg'
import KncvTreeIcon from './svgs/icons/kncv/tree-icon.svg'
import KncvUssdIcon from './svgs/icons/kncv/ussd-icon.svg'

// ── Logos ──────────────────────────────────────────
import SeamhealthLogo from './svgs/logo/seamhealth-logo.svg'
import SeamhealthLogoAlt from './svgs/logo/seamhealth-logo-alt.svg'
import ClientshotLogoWhite from './svgs/logo/clientshot-logo-white.svg'

// ── Backgrounds ────────────────────────────────────
import GlassEffectBg from './svgs/bg/glass-effect.svg'
import GlassEffect2Bg from './svgs/bg/glass-effect2.svg'
import ShadowEffectBg from './svgs/bg/shadow-effect.svg'
import WaveBg from './svgs/bg/wave-bg.svg'
import MapBg from './svgs/bg/map-bg2.svg'

// ── Client Logos ───────────────────────────────────
import UnicefLogo from './images/clients/unicef-logo.svg'
import GatesLogo from './images/clients/gates-foundation-logo.svg'
import ChaiLogo from './images/clients/chai-logo.svg'
import SmileTrainLogo from './images/clients/smiletrain-logo.svg'
import GlobalFundLogo from './images/clients/global-fund-logo.svg'
import FmohLogo from './images/clients/fmoh-logo.svg'
import EkitiClientLogo from './images/clients/ekiti-logo.svg'
import IhvnLogo from './images/clients/ihvn.svg'
import SmiletrainClient from './images/clients/smiletrain.svg'
import Asco from './images/clients/asco.svg'
import Phr from './images/clients/phr.svg'
import KncvClient from './images/clients/kncv.svg'
import Smile from './images/clients/smile.svg'
import Cdc from './images/clients/cdc.svg'
import Scidar from './images/clients/scidar.svg'

// ── Homepage ───────────────────────────────────────
import IhvnNigeria from './images/homepage/ihvn-nigeria.png'
import KncvNigeria from './images/homepage/kncv-nigeria.png'

// ── Services ───────────────────────────────────────
import ServiceCover3 from './images/services/service-3.png'
import ServiceImg3520 from './images/services/img-3520.png'
import AdvisoryCover from './images/services/advisory-cover.png'
import AdvisoryWork from './images/services/advisory-work.png'
import DigitalHealthCover from './images/services/digital-health-cover.png'
import HealthDataAnalytics2 from './images/services/health-data-analytics-2.png'

// ── Team ───────────────────────────────────────────
import Adetola from './images/team/adetola.png'
import Tosin from './images/team/tosin.png'
import Lilian from './images/team/lilian.png'
import Doose from './images/team/doose.png'
import GroupPicture from './images/team/group-picture.webp'
import Ayoola from './images/team/ayoola.webp'
import Ayomide from './images/team/ayomide.png'
import Triumph from './images/team/triumph.png'
import Cornelius from './images/team/cornelius.png'
import Emmanuel from './images/team/emmanuel.png'
import Efe from './images/team/efe.png'
import Attah from './images/team/attah.png'
import Martha from './images/team/martha.png'

// ── About ──────────────────────────────────────────
import AboutTeam01 from './images/about/team-retreat-jan-2025/about-team-01.jpg'
import AboutTeam02 from './images/about/team-retreat-jan-2025/about-team-02.jpg'
import AboutTeam03 from './images/about/team-retreat-jan-2025/about-team-03.jpg'
import AboutTeam04 from './images/about/team-retreat-jan-2025/about-team-04.jpg'
import AboutTeam05 from './images/about/team-retreat-jan-2025/about-team-05.jpg'
import AboutTeam06 from './images/about/team-retreat-jan-2025/about-team-06.jpg'
import AboutTeam07 from './images/about/team-retreat-jan-2025/about-team-07.jpg'
import AboutTeam08 from './images/about/team-retreat-jan-2025/about-team-08.jpg'
import AboutTeam09 from './images/about/team-retreat-jan-2025/about-team-09.jpg'

// ── Top-Level Images ──────────────────────────────
import ClientshotMockup from './images/clientshot-mockup.png'
import Consultation from './images/consultation.webp'
import Development from './images/development.webp'
import AppDevelopment from './images/app-development.webp'
import SystemIntegration from './images/system-integration.webp'
import LegacySystem from './images/legacy-system.webp'
import Support from './images/support.webp'
import NursePortrait from './images/nurse-portrait-hospital.png'
import PatternBg from './images/pattern-bg.png'
import PatternBgFlipped from './images/pattern-bg-flipped.png'
import GlassEffect from './images/glass-effect.webp'
import TeamBg from './images/team-bg.webp'

// ── Project: BRIDGE ────────────────────────────────
import BridgeMockup from './images/projects/bridge-mockup.png'
import BridgeLogo from './images/projects/bridge-logo.svg'
import BridgeLogoAlt from './images/projects/bridge-logo-alt.svg'
import BridgeHero from './images/projects/bridge-mockup/bridge-hero.png'
import BridgeHeroNew from './images/projects/bridge-mockup/gallery/bridge-hero-new-1.png'

import BridgeDemo from './images/projects/bridge-mockup/bridge-demo.png'
import BridgeProblem from './images/projects/bridge-mockup/bridge-problem.png'
import BillGatesLogo from './images/projects/bridge-mockup/bill-gates-logo.svg'
import BridgeTraining from './images/projects/bridge-mockup/gallery/bridge-training.png'
import BridgeCommunity from './images/projects/bridge-mockup/gallery/bridge-community.png'
import BridgeGallery1 from './images/projects/bridge-mockup/gallery/bridge-gallery-1.png'
import BridgeGallery2 from './images/projects/bridge-mockup/gallery/bridge-gallery-2.png'
import BridgeGallery3 from './images/projects/bridge-mockup/gallery/bridge-gallery-3.png'

// ── Project: SmileTrain ────────────────────────────
import SmileTrainMockup from './images/projects/smile-train-mockup.png'
import SmiletrainLogo from './images/projects/smiletrain-logo.svg'
import SmiletrainHero from './images/projects/smiletrain-mockup/smiletrain-hero.png'
import SmiletrainHeroNew from './images/projects/smiletrain-mockup/gallery/smiletrain-hero.png'
import SmiletrainThumbnail from './images/projects/smiletrain-mockup/smiletrain-thumbnail.png'



import SmiletrainGallery1 from './images/projects/smiletrain-mockup/gallery/smiletrain-gallery-1.png'
import SmiletrainGallery2 from './images/projects/smiletrain-mockup/gallery/smiletrain-gallery-2.png'
import SmiletrainGallery3 from './images/projects/smiletrain-mockup/gallery/smiletrain-gallery-3.png'
import SmiletrainGallery4 from './images/projects/smiletrain-mockup/gallery/smiletrain-gallery-4.png'

// ── Project: Ekiti ─────────────────────────────────
import EkitiHealthMockup from './images/projects/ekiti-health-mockup.png'

import EkitiHero from './images/projects/ekiti-mockup/ekiti-hero.png'
import EkitiKeyFeatures from './images/projects/ekiti-mockup/ekiti-key-features.png'
import EkitiBuilt from './images/projects/ekiti-mockup/ekiti-built.png'
import EkitiProblem from './images/projects/ekiti-mockup/gallery/ekiti-problem.png'
import EkitiOutreach from './images/projects/ekiti-mockup/gallery/ekiti-outreach.png'
import EkitiBuiltDeployed from './images/projects/ekiti-mockup/gallery/ekiti-built-deployed.png'
import EkitiLogoPng from './images/projects/ekiti-logo.png'

// ── Project: KNCV ─────────────────────────────────
import KncvMockup from './images/projects/kncv-mockup.png'

import KncvLogo2 from './images/projects/kncv-logo2.svg'
import KncvLogoAlt from './images/projects/kncv-logo-alt.png'
import KncvHero from './images/projects/kncv-mockup/kncv-hero.png'
import KncvGallery3 from './images/projects/kncv-mockup/gallery/kncv-gallery-3.png'
import KncvGallery4 from './images/projects/kncv-mockup/gallery/kncv-gallery-4.png'
import KncvGallery5 from './images/projects/kncv-mockup/gallery/kncv-gallery-5.png'
import KncvGallery6 from './images/projects/kncv-mockup/gallery/kncv-gallery-6.png'

// ── Project: EHR ──────────────────────────────────
import EhrWhatwedo1 from './images/projects/ehr-mockup/gallery/ehr-whatwedo-1.jpg'
import EhrWhatwedo2 from './images/projects/ehr-mockup/gallery/ehr-whatwedo-2.jpg'
import EhrWhatwedo3 from './images/projects/ehr-mockup/gallery/ehr-whatwedo-3.jpg'
import EhrDeployBottomLeft from './images/projects/ehr-mockup/gallery/ehr-deploy-bottom-left.jpg'
import EhrValue1 from './images/projects/ehr-mockup/gallery/ehr-value-1.jpg'

import EhrImg3116 from './images/projects/ehr-mockup/gallery2/img-3116-2.jpeg'
import EhrDhs1 from './images/projects/ehr-mockup/gallery2/ehr-dhs-1.jpg'
import EhrDhs2 from './images/projects/ehr-mockup/gallery2/ehr-dhs-2.jpg'
import EhrDhs3 from './images/projects/ehr-mockup/gallery2/ehr-dhs-3.jpg'
import EhrDhs4 from './images/projects/ehr-mockup/gallery2/ehr-dhs-4.jpg'
import EhrHda1 from './images/projects/ehr-mockup/gallery2/ehr-hda-1.jpg'
import EhrHda2 from './images/projects/ehr-mockup/gallery2/ehr-hda-2.jpg'
import EhrHda4 from './images/projects/ehr-mockup/gallery/ehr-hda-4.png'
import EhrIa1 from './images/projects/ehr-mockup/gallery2/ehr-ia-1.jpg'
import EhrIa2 from './images/projects/ehr-mockup/gallery2/ehr-ia-2.jpg'
import EhrIa3 from './images/projects/ehr-mockup/gallery2/ehr-ia-3.jpg'
import EhrIa4 from './images/projects/ehr-mockup/gallery/ehr-ia-4.png'

import EhrIa5 from './images/projects/ehr-mockup/gallery2/ehr-ia-5.jpg'
import EhrImg3336 from './images/projects/ehr-mockup/gallery2/img-3336-2.jpeg'
import EhrImg5a9f from './images/projects/ehr-mockup/gallery2/5a9f8378-6688-45f3-ba21-549bf1fc23c4.jpeg'
import EhrImg3122 from './images/projects/ehr-mockup/gallery2/img-3122.png'
import EhrImg4890 from './images/projects/ehr-mockup/gallery2/img-4890.png'
import EhrStory4 from './images/homepage/ehr-story-4.png'

// ── Project: Clientshot ───────────────────────────
import ClientshotMockup2 from './images/projects/clientshot-mockup2.png'
import Clientshot001 from './images/projects/clientshot-mockups/clientshot001.png'
import Clientshot002 from './images/projects/clientshot-mockups/clientshot002.png'
import Clientshot003 from './images/projects/clientshot-mockups/clientshot003.png'
import Clientshot004 from './images/projects/clientshot-mockups/clientshot004.png'
import Clientshot005 from './images/projects/clientshot-mockups/clientshot005.png'
import Clientshot006 from './images/projects/clientshot-mockups/clientshot006.png'
import ClientshotImg01 from './images/projects/clientshot-mockups/clientshot-img01.png'
import Apin01 from './images/projects/clientshot-mockups/apin01.jpg'
import Apin02 from './images/projects/clientshot-mockups/apin02.jpg'
import Deployment1 from './images/projects/clientshot-mockups/deployment/deployment-1.jpg'
import Deployment2 from './images/projects/clientshot-mockups/deployment/deployment-2.jpg'
import Deployment3 from './images/projects/clientshot-mockups/deployment/deployment-3.jpg'
import Deployment4 from './images/projects/clientshot-mockups/deployment/deployment-4.jpg'
import Deployment5 from './images/projects/clientshot-mockups/deployment/deployment-5.jpg'
import Deployment6 from './images/projects/clientshot-mockups/deployment/deployment-6.jpg'
import ClientshotProjectCard from './images/projects/clientshot-mockups/gallery/clientshot-project-card.jpg'
import Img4451 from './images/projects/clientshot-mockups/gallery/img-4451.jpg'
import Img4452 from './images/projects/clientshot-mockups/gallery/img-4452.jpg'
import Img4317 from './images/projects/clientshot-mockups/gallery/img-4317.jpg'
import NthripHero from './images/projects/clientshot-mockups/gallery/nthrip-hero.png'
import NthripHeroNew from './images/projects/clientshot-mockups/gallery/nthrip-hero-new.png'
import NthripBuiltDeployed from './images/projects/clientshot-mockups/gallery/nthrip-built-deployed.png'
import NthripGeography from './images/projects/clientshot-mockups/gallery/nthrip-geography.png'
import NthripKeyFeatures from './images/projects/clientshot-mockups/gallery/nthrip-key-features.png'
import NthripProjectCard from './images/projects/clientshot-mockups/gallery/nthrip-project-card.png'
import NthripThumbnail from './images/projects/clientshot-mockups/gallery/nthrip-thumbnail.png'
import OpencrvsProjectCard from './images/projects/opencrvs-mockup/gallery/opencrvs-project-card.png'
import Image18 from './images/projects/clientshot-mockups/gallery/image-18.png'
import Image19 from './images/projects/clientshot-mockups/gallery/image-19.png'

// ── Project: Talamus ──────────────────────────────
import TalamusMockup from './images/projects/talamus-mockup/mockup/talamus-mockup.png'
import TalamusProblem from './images/projects/talamus-mockup/gallery/talamus-problem.png'
import TalamusBuilt from './images/projects/talamus-mockup/gallery/talamus-built.png'
import TalamusCard from './images/projects/talamus-mockup/gallery/talamus-card.png'
import TalamusHeroNew from './images/projects/talamus-mockup/gallery/talamus-hero-new.png'
import TalamusHero from './images/projects/talamus-mockup/gallery/talamus-hero.png'
import TalamusWhatWeDid from './images/projects/talamus-mockup/gallery/talamus-what-we-did.png'
import TalamusProject from './images/projects/talamus-mockup/gallery/talamus-project.png'

// ── Project: General ──────────────────────────────
import ProjectStacks from './images/projects/project-stacks.webp'

// ── Publications ──────────────────────────────────
import InterestConference from './images/interest-publication/interest-2025-conference.jpg'
import InterestTeamPoster from './images/interest-publication/interest-2025-team-poster.jpg'
import InterestDelegates from './images/interest-publication/interest-2025-delegates.jpg'
import InterestSpeaker from './images/interest-publication/interest-2025-speaker.jpg'
import InterestTeamSelfie from './images/interest-publication/interest-2025-team-selfie.jpg'

import InterestBackdrop from './images/interest-publication/interest-2025-backdrop.png'
import InterestAbstract346 from './images/interest-publication/document/interest-2025-abstract-346.pdf'
import InterestAbstract987 from './images/interest-publication/document/interest-2025-abstract-987.pdf'

// ── Videos ─────────────────────────────────────────
import FuturisticBackground from './videos/futuristic-background.mp4'
import ClientshotDocumentary from './videos/hero/clientshot-documentary-new.mp4'
import ProjectVid from './videos/project-vid.mp4'

import AboutVid from './videos/about-vid.mp4'
import MissionVid from './videos/mission-vid.mp4'
import VisionVid from './videos/vision-vid.mp4'

import ClientshotDeploymentVideo from './images/projects/clientshot-mockups/deployment/videos/clientshot-deployment.mp4'
import ClientshotProblemVideo1 from './images/projects/clientshot-mockups/deployment/videos/clientshot-problem-1.mp4'
import ClientshotProblemVideo2 from './images/projects/clientshot-mockups/deployment/videos/clientshot-problem-2.mp4'
import ClientshotProblemVideo3 from './images/projects/clientshot-mockups/deployment/videos/clientshot-problem-3.mp4'

export const Images = {
  // Icons
  ArrowUpRight,
  ArrowRight,
  MenuIcon,
  CloseIcon,
  LightBulbIcon,
  UserIcon,
  MailIcon,
  CircleIcon,
  CircleIconAlt,
  LinkedinIcon,
  InstagramIcon,
  FacebookIcon,
  ArrowDown,
  TelehealthIcon,

  SolutionDesign,
  EhrIcon,
  MobileHealthIcon,
  PatientPortalIcon,
  HealthcareAnalytics,
  AppointmentIcon,
  PatientMonitoringIcon,
  MedicalBillingIcon,
  ClinicDecisionIcon,
  PracticeIcon,

  // Approach Icons
  AssessmentIcon,
  TechnologyIcon,
  DataIcon,
  TestingIcon,
  MaintenanceIcon,
  PerformanceIcon,
  ConfigurationIcon,

  // Values Icons
  TrophyIcon,
  ClientFocusIcon,
  PartnerIcon,
  LightbulbValuesIcon,
  CollaboIcon,

  SocialIcon,

  // BRIDGE Feature Icons
  BridgeAssessmentIcon,
  EducationIcon,
  OfflineIcon,
  ReferralIcon,
  BridgeSecureIcon,
  BridgeTreeIcon,

  // Ekiti Feature Icons
  ComprehensiveIcon,
  PostCovidIcon,
  UssdIcon,

  EkitiSecureIcon,
  InterfaceIcon,

  // KNCV Feature Icons
  KncvComprehensiveIcon,
  IntegrationIcon,
  KncvSecureIcon,
  KncvTreeIcon,
  KncvUssdIcon,

  // Logos
  SeamhealthLogo,
  SeamhealthLogoAlt,
  ClientshotLogoWhite,

  // Backgrounds
  GlassEffectBg,
  GlassEffect2Bg,
  ShadowEffectBg,
  WaveBg,
  MapBg,

  // Client Logos
  UnicefLogo,
  GatesLogo,
  ChaiLogo,
  SmileTrainLogo,
  GlobalFundLogo,
  FmohLogo,
  EkitiClientLogo,
  IhvnLogo,
  SmiletrainClient,
  Asco,
  Phr,
  KncvClient,
  Smile,
  Cdc,
  Scidar,

  // Homepage
  IhvnNigeria,
  KncvNigeria,

  // Services
  ServiceCover3,
  ServiceImg3520,
  AdvisoryCover,
  AdvisoryWork,
  DigitalHealthCover,
  HealthDataAnalytics2,

  // Team
  Adetola,
  Tosin,
  Lilian,
  Doose,
  GroupPicture,
  Ayoola,
  Ayomide,
  Triumph,
  Cornelius,
  Emmanuel,
  Efe,
  Attah,
  Martha,

  // About
  AboutTeam01,
  AboutTeam02,
  AboutTeam03,
  AboutTeam04,
  AboutTeam05,
  AboutTeam06,
  AboutTeam07,
  AboutTeam08,
  AboutTeam09,

  // Top-Level Images
  ClientshotMockup,
  Consultation,
  Development,
  AppDevelopment,
  SystemIntegration,
  LegacySystem,
  Support,
  NursePortrait,
  PatternBg,
  PatternBgFlipped,
  GlassEffect,
  TeamBg,

  // Project: BRIDGE
  BridgeMockup,
  BridgeLogo,
  BridgeLogoAlt,
  BridgeHero,

  BridgeDemo,
  BridgeProblem,
  BillGatesLogo,
  BridgeTraining,
  BridgeCommunity,
  BridgeGallery1,
  BridgeGallery2,
  BridgeGallery3,
  BridgeHeroNew,

  // Project: SmileTrain
  SmileTrainMockup,
  SmiletrainLogo,
  SmiletrainHero,
  SmiletrainHeroNew,
  SmiletrainThumbnail,

  SmiletrainGallery1,
  SmiletrainGallery2,
  SmiletrainGallery3,
  SmiletrainGallery4,

  // Project: Ekiti
  EkitiHealthMockup,

  EkitiHero,
  EkitiKeyFeatures,
  EkitiBuilt,
  EkitiProblem,
  EkitiOutreach,
  EkitiBuiltDeployed,
  EkitiLogoPng,

  // Project: KNCV
  KncvMockup,

  KncvLogo2,
  KncvLogoAlt,
  KncvHero,
  KncvGallery3,
  KncvGallery4,
  KncvGallery5,
  KncvGallery6,

  // Project: EHR
  EhrWhatwedo1,
  EhrWhatwedo2,
  EhrWhatwedo3,
  EhrDeployBottomLeft,
  EhrValue1,

  EhrImg3116,
  EhrDhs1,
  EhrDhs2,
  EhrDhs3,
  EhrDhs4,
  EhrHda1,
  EhrHda2,
  EhrHda4,
  EhrIa1,
  EhrIa2,
  EhrIa3,
  EhrIa4,

  EhrIa5,
  EhrImg3336,
  EhrImg5a9f,
  EhrImg3122,
  EhrImg4890,
  EhrStory4,

  // Project: Clientshot
  ClientshotMockup2,
  Clientshot001,
  Clientshot002,
  Clientshot003,
  Clientshot004,
  Clientshot005,
  Clientshot006,
  ClientshotImg01,
  Apin01,
  Apin02,
  Deployment1,
  Deployment2,
  Deployment3,
  Deployment4,
  Deployment5,
  Deployment6,
  ClientshotProjectCard,
  Img4451,
  Img4452,
  Img4317,
  NthripHero,
  NthripHeroNew,
  NthripBuiltDeployed,
  NthripGeography,
  NthripKeyFeatures,
  NthripProjectCard,
  OpencrvsProjectCard,
  NthripThumbnail,
  Image18,
  Image19,

  // Project: Talamus
  TalamusMockup,
  TalamusProblem,
  TalamusBuilt,
  TalamusCard,
  TalamusHeroNew,
  TalamusHero,
  TalamusWhatWeDid,
  TalamusProject,

  // Project: General
  ProjectStacks,

  // Publications
  InterestConference,
  InterestTeamPoster,
  InterestDelegates,
  InterestSpeaker,
  InterestTeamSelfie,

  InterestBackdrop,
  InterestAbstract346,
  InterestAbstract987,

  // Videos
  FuturisticBackground,
  ClientshotDocumentary,
  ProjectVid,

  AboutVid,
  MissionVid,
  VisionVid,
  ClientshotDeploymentVideo,
  ClientshotProblemVideo1,
  ClientshotProblemVideo2,
  ClientshotProblemVideo3,
}
